import React from "react";
import Modal from "./Modal";
import styled from "styled-components";
import { Colors } from "../../config";
import Button from "./Button";
import Typography from "./Typography";
import Filler from "./Filler";
import IconButton from "./IconButton";
import LeaveDetailsItem from "./LeaveDetailsItem";
import bizSuccessImg from "../../assets/images/biz_success_img.png";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import TravelCard from "./TravelCard";

const SuccessBookingDialog = ({ leaveDetails, bizData, bookingId }) => {
  const navigate = useNavigate();

  return (
    <Modal>
      <SuccessBookingDialogContainer>
        <HeaderContainer>
          <CloseIcon src={require("../../assets/images/biz_tick_circle.png")} />
          <Typography
            fontColor={Colors.prussianBlue}
            fontSize={"18px"}
            fontWeight={"700"}
          >
            Booking Request Successful!
          </Typography>
          <div fontColor={Colors.black} fontSize={"13px"}>
            Your business trip and leave request has been submitted
            successfully. Please check the status of your request on the booking
            status page
          </div>
        </HeaderContainer>
        <TravelCard
          bizSuccessImg={bizSuccessImg}
          bookingId={bookingId}
          leaveDetails={leaveDetails}
          bizData={bizData}
        />
        <div style={{ marginTop: "1rem" }}>
          <Button
            label="Go To Booking Details Page"
            color={Colors.red}
            isRounded
            width="350px"
            onClick={() => navigate("/user/bookings")}
          />
        </div>
      </SuccessBookingDialogContainer>
    </Modal>
  );
};

const SuccessBookingDialogContainer = styled.div`
  width: 50%;
  height: auto;
  padding: 1.5rem;
  background: ${Colors.white};
  border-radius: 0.5rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  // justify-content: center;
  align-items: center;
  @media only screen and (max-width: 768px) {
    width: 90%;
  }
`;

const CloseIcon = styled.img`
  width: 4rem;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
  gap: 0.5rem;
`;

export default SuccessBookingDialog;
